var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0818 3.90903L8.164 2.81584C2.49504 7.49604 0.259519 12.082 0.276481 16.782C0.350396 20.6541 2.3511 23.3685 6.09076 22.7091C8.74789 22.2405 10.9919 20.0046 11.0578 16.9258C10.938 13.3685 8.60257 11.6333 6.05484 11.5713C6.44451 8.02651 9.98337 3.92639 10.0818 3.90903ZM19.6992 8.96101C20.2047 5.49798 23.5642 1.53171 23.6627 1.51436L21.7449 0.421169C16.0759 5.10136 13.8404 9.68734 13.8574 14.3873C13.9313 18.2594 15.932 20.9738 19.6716 20.3144C22.3288 19.8459 24.5728 17.6099 24.5403 14.5484C24.5188 10.9739 22.2469 9.02297 19.6992 8.96101Z",
    fill: "url(#paint0_radial_10_348)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10_348",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.83473 6.57416) rotate(50.9542) scale(18.2266 21.897)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.c51c0445e5c3fb24ee99b5080c1638eb.svg";
export { ForwardRef as ReactComponent };